import React from 'react';

import Textfield from '@atlaskit/textfield/text-field';

export default function TextFieldAppearanceSubtle(): React.JSX.Element {
	// eslint-disable-next-line @atlaskit/design-system/no-placeholder
	return <Textfield appearance="subtle" label="Subtle" placeholder="" />;
}
